export default function initModals() {
    const body = document.querySelector("body");

    function toggleModal(id) {
        const modal = document.querySelector(`[data-modal][id="${id}"]`);

        modal.classList.toggle("opacity-0");
        modal.classList.toggle("pointer-events-none");
        modal.setAttribute(
            "aria-hidden",
            modal.getAttribute("aria-hidden") === "true" ? "false" : "true"
        );
        body.classList.toggle("modal-active");
    }

    const modalTriggers = document.querySelectorAll(
        "[data-modal-trigger], [href='#inspiration-form']"
    );
    modalTriggers.forEach((modalTrigger) => {
        modalTrigger.addEventListener("click", (event) => {
            event.preventDefault();
            let target = event.currentTarget.getAttribute("href");
            if (target.includes("#")) {
                target = event.currentTarget.getAttribute("href").substring(1);
            }

            toggleModal(target);
        });
    });

    const modalOverlays = document.querySelectorAll(
        "[data-modal] .modal-overlay"
    );
    modalOverlays.forEach((modalOverlay) => {
        modalOverlay.addEventListener("click", (event) => {
            toggleModal(
                event.currentTarget.closest("[data-modal]").getAttribute("id")
            );
        });
    });

    const modalCloseButtons = document.querySelectorAll(
        "[data-modal] .modal-close"
    );
    modalCloseButtons.forEach((modalCloseButton) => {
        modalCloseButton.addEventListener("click", (event) => {
            toggleModal(
                event.currentTarget.closest("[data-modal]").getAttribute("id")
            );
        });
    });

    document.addEventListener("keydown", (event) => {
        const isEscape = event.key === "Escape" || event.key === "Esc";
        if (isEscape && document.body.classList.contains("modal-active")) {
            toggleModal(
                document
                    .querySelector('[data-modal][aria-hidden="false"]')
                    .getAttribute("id")
            );
        }
    });
}
